export default "__VITE_ASSET__BQDxV8Vx__"